import { SolarDate } from "@nghiavuive/lunar_date_vi";
import { convertLunaDate } from "../function/convertLunaDate";
import { CalendarCell } from "../models/calender";
const THIEN_CAN = [
  "Giáp",
  "Ất",
  "Bính",
  "Đinh",
  "Mậu",
  "Kỷ",
  "Canh",
  "Tân",
  "Nhâm",
  "Quý",
];

const DIA_CHI = [
  "Tý",
  "Sửu",
  "Dần",
  "Mão",
  "Thìn",
  "Tỵ",
  "Ngọ",
  "Mùi",
  "Thân",
  "Dậu",
  "Tuất",
  "Hợi",
];
export function generateCalendarGrid(
  year: number,
  month: number
): CalendarCell[] {
  const result: CalendarCell[] = [];

  const firstDayOfMonth = new Date(year, month - 1, 1);
  const lastDayOfMonth = new Date(year, month, 0);

  const startWeekday = firstDayOfMonth.getDay(); // 0 = CN
  const prevMonthLastDate = new Date(year, month - 1, 0);

  const todayIso = toLocalISODate(new Date());
  // Chuẩn hóa thứ về T2 = 0
  const leadingDays = startWeekday === 0 ? 6 : startWeekday - 1;

  const buildCell = (d: Date, isCurrentMonth: boolean): CalendarCell => {
    const iso = toLocalISODate(d);

    // ✅ Dùng hàm của bạn
    const { lunarUTC } = convertLunaDate(d);

    return {
      date: d,
      iso,
      day: d.getDate(),
      isCurrentMonth,
      isToday: iso === todayIso,
      lunarDate: lunarUTC, // ✅ Date dạng UTC của bạn
      lunarIso: lunarUTC.toISOString().slice(0, 10),
    };
  };

  /* ===== 1. Ngày mờ tháng trước ===== */
  for (let i = leadingDays; i > 0; i--) {
    const d = new Date(
      prevMonthLastDate.getFullYear(),
      prevMonthLastDate.getMonth(),
      prevMonthLastDate.getDate() - i + 1
    );
    result.push(buildCell(d, false));
  }

  /* ===== 2. Ngày tháng hiện tại ===== */
  for (let day = 1; day <= lastDayOfMonth.getDate(); day++) {
    const d = new Date(year, month - 1, day);
    result.push(buildCell(d, true));
  }

  /* ===== 3. Ngày mờ tháng sau ===== */
  const totalCells = 42;
  const remaining = totalCells - result.length;

  for (let i = 1; i <= remaining; i++) {
    const d = new Date(year, month, i);
    result.push(buildCell(d, false));
  }

  return result;
}
const toLocalISODate = (date: Date) => {
  const tzOffset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - tzOffset).toISOString().slice(0, 10);
};

export function getCanChiYear(year: number) {
  const canIndex = (year + 6) % 10;
  const chiIndex = (year + 8) % 12;

  return `${THIEN_CAN[canIndex]} ${DIA_CHI[chiIndex]}`;
}
export function getCanChiMonth(lunarYear: number, lunarMonth: number) {
  const canIndex = (lunarYear * 12 + lunarMonth + 3) % 10;
  const chiIndex = (lunarMonth + 1) % 12;

  return `${THIEN_CAN[canIndex]} ${DIA_CHI[chiIndex]}`;
}
// export function getCanChiDay(date: Date) {
//   const baseDate = new Date(1900, 0, 1); // 1/1/1900
//   const diffDays = Math.floor((date.getTime() - baseDate.getTime()) / 86400000);

//   const canIndex = (diffDays + 10) % 10;
//   const chiIndex = (diffDays + 12) % 12;

//   return `${THIEN_CAN[canIndex]} ${DIA_CHI[chiIndex]}`;
// }
// Julian Day Number
function toJulianDayNumber(y: number, m: number, d: number): number {
  let yy = y;
  let mm = m;
  if (mm <= 2) {
    yy -= 1;
    mm += 12;
  }
  const A = Math.floor(yy / 100);
  const B = 2 - A + Math.floor(A / 4);
  const jd =
    Math.floor(365.25 * (yy + 4716)) +
    Math.floor(30.6001 * (mm + 1)) +
    d +
    B -
    1524.5;
  return Math.floor(jd + 0.5);
}

/**
 * Trả về Can/Chi của NGÀY (chuẩn, dựa trên JDN)
 * - date: JS Date (chỉ dùng phần Y/M/D)
 * - trả về object { jdn, canIndex, chiIndex, can, chi, text }
 */
export function getCanChiDay(date: Date) {
  const y = date.getFullYear();
  const m = date.getMonth() + 1;
  const d = date.getDate();

  const jdn = toJulianDayNumber(y, m, d);

  // OFFSET chuẩn để map JDN -> Can/Chi của ngày
  const canIndex = (jdn + 9) % 10; // 0..9
  const chiIndex = (jdn + 1) % 12; // 0..11

  const can = THIEN_CAN[(canIndex + 10) % 10];
  const chi = DIA_CHI[(chiIndex + 12) % 12];
const text=`${can} ${chi}`
 return text
}
export function getFullCanChi(date: Date) {
  const solar = new SolarDate(date);
  const lunar = solar.toLunarDate().get();

  return {
    year: getCanChiYear(lunar.year),
    month: getCanChiMonth(lunar.year, lunar.month),
    day: getCanChiDay(date),
    lunarRaw: lunar,
  };
}
export function getVietnameseDayInfo(date: Date) {
  const daysOfWeek = [
    "Chủ Nhật",
    "Thứ Hai",
    "Thứ Ba",
    "Thứ Tư",
    "Thứ Năm",
    "Thứ Sáu",
    "Thứ Bảy",
  ];

  const dayOfWeek = daysOfWeek[date.getDay()];
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  return {
    dayOfWeek,
    day,
    month,
    year,
    text: `${dayOfWeek}, ngày ${day} tháng ${month} năm ${year}`,
  };
}
